import React, { useEffect, useState } from 'react';
import { CourseDetailContent } from './CourseDetailContent';
import { CourseDetailOverview } from './CourseDetailOverview';
import { Breadcrumb } from './Breadcrumb';
import { CourseDetailLive } from './CourseDetailLive';
import { CourseDetailOverviewMobile } from './CourseDetailOverviewMobile';
import { getCourseDetailData, getCourseItemData } from '../services/courseService';
import { SHOPPING_CART_EVENTS } from '../constants/app-constants';

export const CourseDetail = ({ props }) => {
  const [courseItem, setCourseItem] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    const fetchCourseDetail = async () => {
      const data = await getCourseDetailData(props?.courseItemId).catch(
        (error) => {
          setErrorMessage(error.message);
          return null;
        }
      );
      if (data) {
        setErrorMessage(null);
      }
      setCourseItem(data);
    };
    fetchCourseDetail();
  }, [props?.courseItemId]);

  return (
    <div className='course-detail flex gap-4'>
      {errorMessage && <p>{errorMessage}</p>}
      {courseItem && (
        <>
          <div className='course-detail-content-wrapper'>
            <Breadcrumb
              items={props?.breadcrumbProps}
              lastItem={courseItem?.title}
            />
            <CourseDetailContent courseItemData={courseItem} />
          </div>
          <div className='course-detail-overview-wrapper'>
            <CourseDetailOverview courseItemData={courseItem} />
            <CourseDetailLive style={{ marginTop: '1.5rem' }} />
          </div>
          <div className='course-detail-overview-mobile-wrapper'>
            <CourseDetailOverviewMobile courseItemData={courseItem} />
          </div>
        </>
      )}
    </div>
  );
};
